import React, { useState, useEffect } from "react";
import HighlightedPest from "../HighlightedPest/HighlightedPest";
import highlightedPestList from "../../variables/highlightedPestList";
import "./PestInformation.css";

const PestInformation = () => {
  const [announcement, setAnnouncement] = useState("");

  // Initial load
  useEffect(() => {
    window.scroll(0, 0);
    setAnnouncement("You are now on the Pests of National Concern page");
    document.title = "Forest Pest Conditions - Pest Information";
  }, []);
  return (
    <main className="grid-container pest-information" id="main-content">
      <div className="grid-row">
        <div className="grid-column">
          <h1 className="main-heading">Pests of National Concern</h1>
          <p>
            Every year, hundreds of native and nonnative insects and diseases
            damage our Nation's forests. The pests found here are considered of
            national concern due to the impacts they have on our forests, local
            economies, and socio-cultural values of forests and forest products.
          </p>
          <div className="visually-hidden" aria-live="polite">
            {announcement}
          </div>
        </div>
      </div>
      <div className="grid-row pest-header">
        <h2>Highlighted Pests</h2>
      </div>
      {highlightedPestList.map((pest) => {
        return <HighlightedPest key={pest.commonName} pestData={pest} />;
      })}
    </main>
  );
};

export default PestInformation;
